<template>
  <div>
    <h1 style="color: white">All Pages</h1>
    <ul>
      <li><router-link to="/">TOP</router-link></li>
      <li><router-link to="/order">オーダーページ</router-link></li>
      <li><router-link to="/order-form">オーダーフォーム</router-link></li>
      <li>
        <router-link to="/shop-order-form">店舗用オーダーフォーム</router-link>
      </li>
      <li><router-link to="/confirmationPage">注文内容確認ページ</router-link></li>
      <li><router-link to="/contact">お問い合わせ</router-link></li>
      <li><router-link to="/inquiry-confirmation">お問い合わせ確認ページ</router-link></li>
      <li><router-link to="/contact-thanks-page">お問い合わせサンクスページ</router-link></li>
      <li><router-link to="/thanks-page">サンクスページ</router-link></li>
      <li><router-link to="/test-links">テストリンク</router-link></li>
      <li><router-link to="/privacy-policy">プライバシーポリシー</router-link></li>
      <li><router-link to="/terms-of-service">利用規約</router-link></li>
      <li><router-link to="/specified-commercial-transactions">特定商取引法に基づく表記</router-link></li>
      <!-- 他のルートを追加 -->
    </ul>
  </div>
</template>

<script>
export default {
  name: "TestLinks",
};
</script>
